import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import agentsActions from "../../store/actions/agents";

const MapMarkerMultiple = ({agents, lat, lng, key}) => {
    const agentsStore = useSelector((store) => store.agentsStore);
    const dispatch = useDispatch();
    const [activeAgent, setActiveAgent] = useState(agents[0])
    const [tooltipShow, setTooltipShow] = useState(false)
    const setActiveMarker = (id) => {
        dispatch(agentsActions.setActiveMarker(id));
        dispatch(agentsActions.setMapCenter({lat, lng}));
    }
    useEffect(() => {
        agents.forEach(agent => {
            if (agent.agentKey === agentsStore.hoveredAgent) {
                setActiveAgent(agent);
            }
        })
    }, [agentsStore.hoveredAgent])

    useEffect(() => {
        let tooltip = false;
        agents.forEach(agent => {
            if (agent.agentKey === agentsStore.activeMarker) {
                tooltip = true;
            }
        })
        setTooltipShow(tooltip);
    }, [agentsStore.activeMarker])

    return (
        <div className={`map-marker multiple ${tooltipShow && 'open'}`}>
            <div className="map-marker-icon">
                <img className="map-marker-icon" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/marker.svg`} alt="marker" onClick={() => setActiveMarker(activeAgent.agentKey)}/>
                <img className="map-marker-icon-before" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/marker.svg`} alt="marker" onClick={() => setActiveMarker(activeAgent.agentKey)}/>
                <div className="map-marker-icon__number">{activeAgent.agentKey}</div>
            </div>
            <div className="map-marker-tooltip">
                <div className="map-marker-tooltip-name">
                    {activeAgent.firstName && (
                        <span>{activeAgent.firstName}</span>
                    )}
                    {activeAgent.middleName && (
                        <span> {activeAgent.middleName}</span>
                    )}
                    {activeAgent.lastName && (
                        <span> {activeAgent.lastName}</span>
                    )}
                </div>
                {activeAgent.agency && (
                    <div className="map-marker-tooltip-agency">
                        {activeAgent.agency.name}
                    </div>
                )}
                <a className="map-marker-link" href={`https://maps.google.com/?q=${lat},${lng}`} target="_blank">Get directions</a>
            </div>
        </div>
    )
};

export default MapMarkerMultiple;

